
import WebConstant from "../../webConstants";
import { mainWrapper } from "../../main";


function citiesList (params) {
    return mainWrapper.get(WebConstant.host + "/cities", params);
};


function statesList (params) {
    return mainWrapper.get(WebConstant.host + "/states", params);
};


function taskPriority (params) {
    return mainWrapper.get(WebConstant.host + "/task_priority", params);
};


export const actionsServices = {
    citiesList,
    statesList,
    taskPriority
};
